import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Refeições",
  path: "/merenda/merrefeicao",
  name: "merrefeicao",
  component: () => import("@/views/merenda/merrefeicao/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.REFEICOESSERVIDASNOVO_MENU_1000200899],
  },
  goesToMenu: true,
 },
];
